var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-new-order section-full"},[(_vm.step==0)?_c('form-order',{attrs:{"tableSelected":this.table,"step":this.step,"title":_vm.$gettext('Create new order')}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }